// extracted by mini-css-extract-plugin
export default {"pageContainer":"style_pageContainer__fwhle","screenWrapper":"style_screenWrapper__aDkvm","label":"style_label__RqJXW"};